import React, { useState } from 'react';
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
  TextField,
  Button,
  Divider,
  ListItemAvatar,
  Avatar,
  Paper,
  InputBase,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { dateFormate } from '../../../utils/helper';
import SendIcon from '@mui/icons-material/Send';
interface Comment {
  comment_by: string;
  comment: string;
  created_at: string;
  created_by?: string;
}

interface CommentBoxProps {
  commentList: Comment[];
  onSubmitComment: (comment: string) => void;
  onRemoveComment?: (item: Comment, index: number) => void;
}

const CommentBox: React.FC<CommentBoxProps> = ({
  commentList,
  onSubmitComment,
  onRemoveComment,
}) => {
  const [comment, setComment] = useState<string>('');

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter' && !e.shiftKey && comment.trim().length > 0) {
      onSubmitComment(comment?.trim());
      setComment('');
      e.preventDefault();
    }
  };

  const handleAddClick = () => {
    if (comment?.trim()?.length > 0) {
      onSubmitComment(comment.trim());
      setComment('');
    }
  };

  return (
    <Box>
      <List sx={{ maxHeight: 300, overflow: 'auto' }}>
        {commentList?.length === 0 &&
          <Typography variant="body2" color="textSecondary">
            No comments available.
          </Typography>
        }

        {commentList?.length > 0 &&
          commentList?.map((item, index) => (
            <React.Fragment key={index}>
              <ListItem alignItems="flex-start">
                <ListItemAvatar>
                  <Avatar>{item?.comment_by?.charAt(0)}</Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={
                    <Typography variant="subtitle2" fontWeight="bold">
                      {item?.comment_by}
                    </Typography>
                  }
                  secondary={
                    <>
                      <Typography variant="body2" color="textPrimary">
                        {item?.comment || ''}
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        {dateFormate(item.created_at, 'DD-MM-YYYY hh:mm a')}   By: {item.created_by}
                      </Typography>
                      {/* {item.created_by && (
                         <Typography variant="caption" color="textSecondary">
                           By: {item.created_by}
                         </Typography>
                       )} */}
                    </>
                  }
                />
                {onRemoveComment &&
                  <ListItemSecondaryAction>
                    <IconButton edge="end" aria-label="delete" onClick={() => onRemoveComment(item, index)}>
                      <DeleteIcon />
                    </IconButton>
                  </ListItemSecondaryAction>

                }
              </ListItem>
              <Divider component="li" />
            </React.Fragment>
          ))}
      </List>
      <Paper
        component="form"
        sx={{ mt: 3, display: 'flex', alignItems: 'center', boxShadow: '0px 0px 3px 0px gray' }}
      >
        <InputBase
          sx={{ ml: 1, flex: 1 }}
          fullWidth
          placeholder="Write comment...."
          inputProps={{ 'aria-label': 'Write text....' }}
          value={comment || ''}
          onChange={(e) => {
            setComment(e?.target?.value);
            const textarea = e.target;
            textarea.style.height = 'auto';
            textarea.style.height = `${Math.min(textarea.scrollHeight, 100)}px`;
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !e.shiftKey && comment.trim().length > 0) {
              onSubmitComment(comment?.trim());
              setComment('');
              e.preventDefault();
            }
          }}
        />
        <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
        {comment?.trim()?.length ?
          <IconButton sx={{ p: '10px' }} onClick={() => handleAddClick()}>
            <SendIcon />
          </IconButton> : null
        }
      </Paper>
    </Box >
  );
};

export default CommentBox;
